import * as React from 'react';

interface PeopleRankIconProps {
  className?: string;
  color?: string;
}

const PeopleToplistIcon = ({ className, color = '#000' }: PeopleRankIconProps): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" className={className}>
      <g fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
        <path
          d="M48.125 100.625h-35a8.75 8.75 0 00-8.75 8.75v26.25h43.75zM126.875 100.625h-35v35h43.75v-26.25a8.75 8.75 0 00-8.75-8.75zM83.125 65.625h-26.25a8.75 8.75 0 00-8.75 8.75v61.25h43.75v-61.25a8.75 8.75 0 00-8.75-8.75zM54.688 19.688a15.313 15.313 0 1030.624 0 15.313 15.313 0 10-30.624 0zM88.953 48.125a24.902 24.902 0 00-37.917 0M101.36 59.063a15.313 15.313 0 1030.625 0 15.313 15.313 0 10-30.625 0zM135.625 87.5a24.85 24.85 0 00-26.25-7.647M8.015 59.063a15.313 15.313 0 1030.625 0 15.313 15.313 0 10-30.625 0zM4.375 87.5a25.002 25.002 0 0118.958-8.75 24.716 24.716 0 017.263 1.097"
          strokeWidth={8.749995}
        />
      </g>
    </svg>
  );
};

export default PeopleToplistIcon;
